module.exports = __webpack_public_path__ + "img/philippines.d17213da.svg";